import { RefreshTokenResponse } from '../../shared/models/ad/refresh-token-response.model';
import { RefreshTokenRequest } from '../../shared/models/ad/refresh-token-request.model';
import { AuthResponse } from '../../shared/models/ad/auth-response.model';
import { AuthRequest } from '../../shared/models/ad/auth-request.model';
import { environment } from '../../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class AdAuthService {
	private readonly url = environment.apiResourceUri + '/auth';

	constructor(private readonly http: HttpClient) { }

	signIn(authRequest: AuthRequest): Observable<AuthResponse> {
		return this.http.post<AuthResponse>(this.url + '/signIn', authRequest);
	}

	refreshToken(refreshTokenRequest: RefreshTokenRequest): Observable<RefreshTokenResponse> {
		return this.http.post<RefreshTokenResponse>(this.url + '/refreshToken', refreshTokenRequest);
	}
}
